import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CondominiumEditPage } from './condominium-edit';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CondominiumEditPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CondominiumEditPage),
	],
})
export class CondominiumEditPageModule { }



// WEBPACK FOOTER //
// ./src/pages/condominium-edit/condominium-edit.module.ts